// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__JgP8m {
    padding: 50px;
}

.centeredContainer__ZRJh0 {
    align-items: center;
    display: flex;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/ErrorFallback/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B","sourcesContent":[".container {\n    padding: 50px;\n}\n\n.centeredContainer {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__JgP8m`,
	"centeredContainer": `centeredContainer__ZRJh0`
};
module.exports = ___CSS_LOADER_EXPORT___;
